export const historyRoutes = [
  {
    path: "/history",
    name: "History",
    component: () => import("@/views/History/History.vue"),
    meta: { parent: "History", menu: true, back: { to: "Dashboard" } },
  },
  {
    path: "/history/filters",
    name: "HistoryFilters",
    component: () => import("@/views/History/HistoryFilters.vue"),
  },
];
